var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useEffect, useRef, useState } from 'react';
import { transformSessionResponse } from '../utils/sessionUtils';
import analytics from '../analytics/analytics';
import { browserStorage } from '../utils/browserStorage';
import useRefreshSessionAccess from './UseRefreshSessionAccess';
/**
 * usePromptRetrieval
 * @public
 */
const usePromptRetrieval = args => {
  const [statusMsg, setStatusMesg] = useState('');
  const [tabVisible, setTabVisible] = useState(true);
  const {
    retrieveUrl,
    cguid,
    setRetrievalLoading,
    setChatMessages,
    setLastPromptId,
    limit = 5,
    isSessionActive,
    productId = 0,
    requestFrom = '',
    chatMessages
  } = args;
  useRefreshSessionAccess();
  const visibilityChangeTimeout = useRef(null);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        visibilityChangeTimeout.current = setTimeout(() => {
          setTabVisible(true);
        }, 500);
      } else {
        clearTimeout(visibilityChangeTimeout.current || 0);
        setTabVisible(false);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (visibilityChangeTimeout.current) {
        clearTimeout(visibilityChangeTimeout.current);
      }
    };
  }, [isSessionActive]);
  useEffect(() => {
    if (!isSessionActive || !tabVisible || typeof window === 'undefined') {
      setStatusMesg('Failed');
      return;
    }
    const shouldFetch = (browserStorage === null || browserStorage === void 0 ? void 0 : browserStorage.getUserMessageCount()) !== (chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.filter(message => (message === null || message === void 0 ? void 0 : message.role) === 'user' && (message === null || message === void 0 ? void 0 : message.content) !== '').length) || chatMessages.length === 0;
    const abortController = new AbortController();
    setTimeout(() => {
      abortController.abort();
    }, 30000); // 30 seconds timeout for fetch request /
    const fetchMe = () => __awaiter(void 0, void 0, void 0, function* () {
      var _a;
      const pennysid = (_a = browserStorage.getItem('pennysid')) !== null && _a !== void 0 ? _a : '';
      return yield fetch(retrieveUrl, {
        method: 'POST',
        signal: abortController.signal,
        body: JSON.stringify({
          pennysid,
          cguid,
          limit,
          isSessionActive,
          productId,
          requestFrom
        })
      });
    });
    if (shouldFetch) {
      setRetrievalLoading(true);
      fetchMe().then(result => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const sessionResult = yield result === null || result === void 0 ? void 0 : result.json();
        if (sessionResult === null || sessionResult === void 0 ? void 0 : sessionResult.token) {
          sessionStorage.setItem('pennysid', sessionResult.token);
        } else {
          analytics.log({
            source: 'usePromptRetrieval',
            message: `Invalid token sent, token is ${sessionResult === null || sessionResult === void 0 ? void 0 : sessionResult.token}`
          });
        }
        const sessionData = sessionResult.data;
        if (sessionData === null || sessionData === void 0 ? void 0 : sessionData.length) {
          const sessionChatMessage = sessionData.map(item => transformSessionResponse(item));
          setLastPromptId((_b = sessionData[0]) === null || _b === void 0 ? void 0 : _b.promptId);
          setChatMessages(sessionChatMessage);
          setStatusMesg('Success');
        }
      })).catch(e => {
        setStatusMesg('Failed');
        analytics.log({
          source: 'Chatbot retrieve error',
          message: e.message
        });
      }).finally(() => setRetrievalLoading(false));
    }
  }, [isSessionActive, tabVisible]);
  return {
    statusMsg
  };
};
export default usePromptRetrieval;